import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

export default class extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired
	};

    render() {

		var { user } = this.props;

		return <span>
			<Link className="small clickable text-mid-gray" to={user.link}>
				View Public Profile
			</Link>
		</span>
	}
}


// WEBPACK FOOTER //
// ./src/js/views/Profile/components/ActionButtons/components/ViewPublic.jsx